import * as CellValueTypes from "./CellValueType";
// Used to produce type predicate functions for each of the CellValue types
const predicateFactory = type => {
  return cell => {
    var _cell$cellValue;
    return ((_cell$cellValue = cell.cellValue) === null || _cell$cellValue === void 0 ? void 0 : _cell$cellValue.cellType) === type;
  };
};
// Used below in type predicates
const CHECKBOX_LIST_TYPES = [...CellValueTypes.CHECKBOX_CELL_CATEGORIES];
export const cellPredicates = {
  isAbstractDateTimeCell: predicateFactory("ABSTRACTDATETIME"),
  isCheckBoxCell: cell => {
    var _cell$cellValue2;
    return CHECKBOX_LIST_TYPES.includes((_cell$cellValue2 = cell.cellValue) === null || _cell$cellValue2 === void 0 ? void 0 : _cell$cellValue2.cellType);
  },
  isContactCell: predicateFactory("CONTACT"),
  isDateCell: predicateFactory("DATE"),
  isDurationCell: predicateFactory("DURATION"),
  isMultiContactCell: predicateFactory("MULTICONTACT"),
  isMultiPickListCell: predicateFactory("MULTIPICKLIST"),
  isNumberCell: predicateFactory("NUMBER"),
  isPickListNumberCell: predicateFactory("PICKLISTNUMBER"),
  isPickListTextCell: predicateFactory("PICKLISTTEXT"),
  isPredecessorCell: predicateFactory("PREDECESSOR"),
  isSystemDateCell: predicateFactory("SYS_DATE"),
  isSystemUserCell: predicateFactory("SYS_USER"),
  isTextCell: predicateFactory("TEXT")
};
//# sourceMappingURL=Cell.js.map